import { IncomingMessage } from 'http';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';
import { mutate } from 'swr';

import { publicConfig } from '@public-config';

import { Article } from 'models';
import { ArticleHelpers } from 'helpers/ArticleHelpers';

import { ApiService } from 'services/ApiService';

const ArticleService = {
    mutate: {
        list: async (company: string, type: string) => {
            const companyId = CollectionHelpers.id(company)!;
            await mutate(ArticleHelpers.swr.list(companyId, type));
        },
    },

    list: async (company: string, type: string) => {
        const { docs } = await ApiService.get<{
            docs: Article[];
        }>(`${publicConfig.urls.api}/articles?where[company][equals]=${company}&where[type][equals]=${type}&limit=0`);

        return docs;
    },

    getMultiple: async (articleIds: string[]) => {
        const params = articleIds.map((id) => `where[id][in]=${id}`).join('&');

        return ApiService.get<{ docs: Article[] }>(`${publicConfig.urls.api}/articles?${params}`);
    },

    get: async (id: Article['id'], req?: IncomingMessage) => {
        const article = await ApiService.get<Article>(`${publicConfig.urls.api}/articles/${id}`, { req });

        return article;
    },

    create: async (data: Article) => {
        const { doc: article } = await ApiService.post<{
            doc: Article;
        }>(`${publicConfig.urls.api}/articles`, data, { throwError: true });

        return article;
    },

    update: async (id: Article['id'], data: Partial<Article>) => {
        const result = await ApiService.patch<{
            doc: Article;
        }>(
            `${publicConfig.urls.api}/articles/${id}`,
            {
                name: data.name,
                file: data.file,
                teaser: data.teaser,
            },
            { throwError: true },
        );

        return result?.doc;
    },

    delete: async (id: Article['id']) => {
        await ApiService.delete(`${publicConfig.urls.api}/articles/${id}`);
    },

    search: async (query?: string) => {
        const params = new URLSearchParams({
            query: JSON.stringify({ search: query, type: 'caseStudy' }),
            page: '0',
            sort: 'relevance',
        });

        return ApiService.get(`${publicConfig.urls.api}/articles/search?${params.toString()}`);
    },
};

export { ArticleService };
